import LazyLoad from './src/LazyLoad';
export default LazyLoad;
